function s (label, options) {
  let res = label;
  Object.entries(options).forEach(option => {
    const regex = new RegExp(`%{${option[0]}}`, "g");
    res = res.replace(regex, option[1]);
  });
  return res;
}

export { s as default };
